<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary mt-50">گزارش ورود و خروج انبار</h3>
        <div v-if="isAdminIdentityVerified">
            <b-row class="mb-2 mb-md-50">
                <b-col xl="3" lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col xl="3" lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col xl="3" lg="3" md="4" class="mt-25">
                    <b-form-group label="دسته‌بندی مواد اولیه (کالا)" label-for="rawMaterialCategoryId">
                        <v-select v-model="parameters.rawMaterialCategoryId" :searchable="false"
                            id="rawMaterialCategoryId" dir="rtl" :options="materialCategories" autocomplete="off"
                            class="bg-white" style="border-radius: 6px;" :reduce="(value) => value.id" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="3" lg="3" md="4" class="mt-25">
                    <b-form-group label="مواد اولیه (کالا)" label-for="rawMaterialId">
                        <v-select v-model="parameters.rawMaterialId" :searchable="false" id="rawMaterialId" dir="rtl"
                            :options="materials" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="2" lg="4" md="4" class="mt-25">
                    <b-form-group label="نوع" label-for="typeId">
                        <v-select v-model="parameters.type" :searchable="false" id="typelId" dir="rtl"
                            :options="typeManagement" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="2" lg="4" md="4" class="mt-25">
                    <b-form-group label="عملیات" label-for="reasonId">
                        <v-select v-model="parameters.reason" :searchable="false" id="reasonId" dir="rtl"
                            :options="reasonManagement" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="2" lg="4" md="3" class="mt-25">
                    <b-form-group label="انبار مبدأ" label-for="sourceWarehouseId">
                        <v-select v-model="parameters.sourceWarehouseId" :searchable="false" id="sourceWarehouseId"
                            dir="rtl" :options="warehouses" autocomplete="off" class="bg-white"
                            style="border-radius: 6px;" :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="2" lg="4" md="3" class="mt-25">
                    <b-form-group label="انبار مقصد" label-for="destinationWarehouseId">
                        <v-select v-model="parameters.destinationWarehouseId" :searchable="false"
                            id="destinationWarehouseId" dir="rtl" :options="warehouses" autocomplete="off"
                            class="bg-white" style="border-radius: 6px;" :reduce="(value) => value.id" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col xl="2" lg="4" md="3" class="mt-md-2 mt-50">
                    <b-button variant="secondary" class="w-100 mt-md-25 mt-0" @click="removeFilters"
                        :disabled="loading">
                        حذف فیلتر ها
                    </b-button>
                </b-col>
                <b-col xl="2" lg="4" md="3" class="mt-md-2 mt-1">
                    <b-button variant="info" @click="getWarehousingStockMovements" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <b-card class="p-0" no-body>
                <div v-if="stockMovements.length">
                    <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-table responsive :items="stockMovements" :fields="fields" class="mb-0" striped>
                            <template #cell(details)="data">
                                <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                                <feather-icon v-else @click="showDetails(data.item, data.index)" size="20"
                                    icon="InfoIcon" class="pointer text-info" color="#8d88a3" />
                            </template>
                            <template #cell(destinationWarehouse)="data">
                                {{ data.item.destinationWarehouse ? data.item.destinationWarehouse.name : '-' }}
                            </template>
                            <template #cell(sourceWarehouse)="data">
                                {{ data.item.sourceWarehouse ? data.item.sourceWarehouse.name : '-' }}
                            </template>
                            <template #cell(type)="data">
                                {{ type_management(data.item.type) }}
                            </template>
                            <template #cell(rawMaterial.unit)="data">
                                {{ unit_management(data.item.rawMaterial.unit) }}
                            </template>
                            <template #cell(reason)="data">
                                {{ reason_management(data.item.reason) }}
                            </template>
                            <template #cell(newQuantity)="data">
                                <span v-b-popover.hover.top="data.item.newQuantity"
                                    :title="data.item.rawMaterial.unit == 1 ? 'گرم' : data.item.rawMaterial.unit == 2 ? 'میلی‌لیتر' : 'عدد'"
                                    class="text-info pointer">
                                    {{
                                        [1, 2].includes(data.item.rawMaterial.unit) ? data.item.newQuantity / 1000 :
                                            data.item.newQuantity
                                    }}
                                </span>
                            </template>
                            <template #cell(previousQuantity)="data">
                                <span v-b-popover.hover.top="data.item.previousQuantity"
                                    :title="data.item.rawMaterial.unit == 1 ? 'گرم' : data.item.rawMaterial.unit == 2 ? 'میلی‌لیتر' : 'عدد'"
                                    class="text-info pointer">
                                    {{
                                        [1, 2].includes(data.item.rawMaterial.unit) ? data.item.previousQuantity / 1000 :
                                            data.item.previousQuantity
                                    }}
                                </span>
                            </template>
                            <template #cell(quantity)="data">
                                <span v-b-popover.hover.top="data.item.quantity"
                                    :title="data.item.rawMaterial.unit == 1 ? 'گرم' : data.item.rawMaterial.unit == 2 ? 'میلی‌لیتر' : 'عدد'"
                                    class="text-info pointer">
                                    {{
                                        [1, 2].includes(data.item.rawMaterial.unit) ? data.item.quantity / 1000 :
                                            data.item.quantity
                                    }}
                                </span>
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                </div>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getWarehousingStockMovements" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal warehousing invoices detail ------------------------------->
        <b-modal id="warehousing-invoices-detail" title="جزئیات فاکتور انبار" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <warehouseInvoiceDetail :invoiceDetails="invoiceDetails" />
        </b-modal>

        <!------------------------------- modal warehousing stockTakings detail ------------------------------->
        <b-modal id="warehousing-stockTakings-detail" title="جزئیات انبارگردانی" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <stockTakingDetail :stockTakingDetails="stockTakingDetails" />
        </b-modal>

        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <invoiceDetail :orderDetails="orderDetails" />
        </b-modal>

    </div>
</template>

<script>
import { VBPopover, BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { required } from '@validations';
import vSelect from 'vue-select';
import warehouseInvoiceDetail from '@/@core/components/warehouse-invoice-detail/index.vue';
import stockTakingDetail from '@/@core/components/stock-taking-detail/index.vue';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect,
        warehouseInvoiceDetail,
        stockTakingDetail,
        invoiceDetail
    },
    directives: {
        'b-popover': VBPopover,
    },
    computed: {
        type_management() {
            return (status) => {
                if (status == 1) {
                    return 'ورودی'
                }
                if (status == 2) {
                    return 'خروجی'
                }
            }
        },
        unit_management() {
            return (status) => {
                if (status == 1) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
        reason_management() {
            return (status) => {
                if (status == 1) {
                    return 'فاکتور خرید انبار'
                }
                if (status == 2) {
                    return 'فاکتور فروش انبار'
                }
                if (status == 3) {
                    return 'فاکتور فروش صندوق'
                }
                if (status == 4) {
                    return 'انبارگردانی'
                }
                if (status == 5) {
                    return 'فاکتور مرجوعی صندوق'
                }
            }
        },
    },
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            isAdminIdentityVerified: false,
            reasonManagement: [
                { name: 'نمایش همه', id: null },
                { name: 'انبارگردانی', id: 4 },
                { name: 'فاکتور خرید انبار', id: 1 },
                { name: 'فاکتور فروش انبار', id: 2 },
                { name: 'فاکتور فروش صندوق', id: 3 },
                { name: 'فاکتور مرجوعی صندوق', id: 5 },
            ],
            typeManagement: [
                { name: 'نمایش همه', id: null },
                { name: 'ورودی', id: 1 },
                { name: 'خروجی', id: 2 },
            ],
            materials: [],
            warehouses: [],
            materialCategories: [],
            stockMovements: [],
            fields: [
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'rawMaterial.name',
                    label: 'نام ماده (کالا)',
                },
                {
                    key: 'rawMaterial.unit',
                    label: 'واحد اندازه‌گیری',
                },
                {
                    key: 'previousQuantity',
                    label: 'موجودی قبل تغییر',
                },
                {
                    key: 'quantity',
                    label: 'مقدار',
                },
                {
                    key: 'newQuantity',
                    label: 'موجودی بعد تغییر',
                },
                {
                    key: 'type',
                    label: 'نوع',
                },
                {
                    key: 'reason',
                    label: 'عملیات',
                },
                {
                    key: 'sourceWarehouse',
                    label: 'انبار مبدأ',
                },
                {
                    key: 'destinationWarehouse',
                    label: 'انبار مقصد',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                referenceNumber: null,
                from: null,
                to: null,
                type: null,
                reason: null,
                rawMaterialId: null,
                rawMaterialCategoryId: null,
                sourceWarehouseId: null,
                destinationWarehouseId: null,
            },
            parametersMaterialCategories: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersMaterials: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersWarehouses: {
                pageIndex: 1,
                pageSize: 90,
            },
            storeId: null,
            invoiceDetails: {},
            stockTakingDetails: {},
            orderDetails: {},
        }
    },
    methods: {
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        showDetails(item, index) {
            this.$set(this.loadingbuttons, index, true);
            let id = item.referenceNumber
            if (item.reason == 1 || item.reason == 2) {
                storeService.getwarehousingInvoicesById(this.storeId, id).then(({ data }) => {
                    this.invoiceDetails = data
                    this.$set(this.loadingbuttons, index, false);
                    this.$bvModal.show('warehousing-invoices-detail')
                })
                    .catch((err) => {
                        this.$set(this.loadingbuttons, index, false);
                    });
            }
            if (item.reason == 4) {
                storeService.getWarehousingStockTakingsById(this.storeId, id).then(({ data }) => {
                    this.stockTakingDetails = data
                    this.$set(this.loadingbuttons, index, false);
                    this.$bvModal.show('warehousing-stockTakings-detail')
                })
                    .catch((err) => {
                        this.$set(this.loadingbuttons, index, false);
                    });
            }
            if (item.reason == 3 || item.reason == 5) {
                storeService.orderDetailsStoreOrderNumber(this.storeId, { storeOrderNumber: id }).then(({ data }) => {
                    this.orderDetails = data.order
                    this.$set(this.loadingbuttons, index, false);
                    this.$bvModal.show('show-order-list')
                })
                    .catch((err) => {
                        this.$set(this.loadingbuttons, index, false);
                    });
            }
        },
        removeFilters() {
            this.parameters.from = null
            this.parameters.to = null
            this.parameters.type = null
            this.parameters.reason = null
            this.parameters.rawMaterialId = null
            this.parameters.rawMaterialCategoryId = null
            this.parameters.sourceWarehouseId = null
            this.parameters.destinationWarehouseId = null
            this.getWarehousingStockMovements()
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingWarehouses();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingStockMovements() {
            this.loading = true
            this.loadingbuttons = []
            storeService.warehousingStockMovements(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.stockMovements = data.items
                    if (this.stockMovements.length) {
                        this.stockMovements.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.stockMovements = data.items
                        if (this.stockMovements.length) {
                            this.stockMovements.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getWarehousingCategories() {
            this.loading = true
            storeService.getWarehousingCategories(this.storeId, this.parametersMaterialCategories).then(({ data }) => {
                this.materialCategories = data.items
                this.materialCategories.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingStockMovements();
            })
        },
        getWarehousingMaterials() {
            storeService.getWarehousingMaterials(this.storeId, this.parametersMaterials).then(({ data }) => {
                this.materials = data.items
                this.materials.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingCategories();
            })
        },
        getWarehousingWarehouses() {
            storeService.getWarehousingWarehouses(this.storeId, this.parametersWarehouses).then(({ data }) => {
                this.warehouses = data.items
                this.warehouses.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingMaterials();
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>